module.exports = __webpack_public_path__ + "img/cartao_discover.a2b6a53e.svg";